import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducers';

export type RootState = ReturnType<typeof rootReducer>;

export default function () {
    const store = configureStore({
        reducer: rootReducer,
        middleware: getDefaultMiddleware =>
            getDefaultMiddleware(),
        devTools: process.env.NODE_ENV !== 'production',
    })

    return store
}
